/* eslint-disable max-len */
// Node Module Imports
import React from 'react'

import { Link } from 'gatsby'
import styled from 'styled-components'

// Component Imports

// Style Imports
import { above, space } from '../../../style/design-system'

// other
import { studentInfo } from '../../../utils/static-data/studentInfo'
import ChevronBackgroundStroke from '../../elements/ChevronBackgroundStroke'

const BigNumberStatsHome = ({ className }) => (
  <div className={className}>
    <ChevronBackgroundStroke direction="east">
      <div className="container py-10">
        <div className="row">
          <div className="col-12 col-md-6 col-xl-4 offset-xl-2 text-center order-1 order-md-0">
            <div className="big-num blue">{studentInfo.yearsInBusiness}</div>
            <div className="big-num-large-text blue upper">Years</div>
            <div className="big-num-small-text upper">in Healthcare Education</div>
          </div>
          <div className="col-12 col-md-6 col-xl-4 text-center order-0 order-md-1">
            <div className="established h3 blue">Established, 1994.</div>
            <p className="established-text text-left">
              We are a nonprofit with a national presence and
              {' '}
              {studentInfo.yearsInBusiness}
              + years focused on allied healthcare.
            </p>
            <div className="h4 black established-header text-left mb-6">
              Longstanding partnerships.
              <br />
              Strong record.
            </div>
            <p className="established-paragraph text-left">We're proud of the longstanding partnerships that we've developed with over 1,000 employers &ndash; some Fortune 500 companies, some small-to-medium businesses. Our partners range from regional health insurers, to large hospital systems, to national pharmacy chains and more. Let us show you how uncomplicated and effortless finding the right healthcare talent can be.</p>
          </div>
        </div>
        <div className="bottom-stats text-center">
          <div className="stat stat-1">
            <div className="stat-number blue px-3">
              1000
              <span className="smaller super">+</span>
            </div>
            <div className="stat-text upper px-3">Employer Partners</div>
          </div>
          <div className="stat stat-2">
            <div className="stat-number blue px-3">
              {studentInfo.careerSupport.numberTeamMembers}
              <span className="smaller super">+</span>
            </div>
            <div className="stat-text upper px-3">Career Support Team Members</div>
          </div>
          <div className="stat stat-3">
            <div className="stat-number blue px-3">
              {Math.floor(studentInfo.grads.numberInThousands)}
              <span className="smaller">K+</span>
            </div>
            <div className="stat-text upper px-3">Alumni Since 1994</div>
          </div>
        </div>
        <div className="text-center">
          <Link to="/employers/positions-we-staff/" className="btn btn-outline-black">Positions We Staff&nbsp;&gt;</Link>
        </div>
      </div>
    </ChevronBackgroundStroke>
  </div>
)

export default styled(BigNumberStatsHome)`
  .big-num {
    font-size: 50vw;
    line-height: 1;
    ${above.md`
      font-size: 19rem;
      margin-top: -4rem;
    `}
    ${above.lg`
      font-size: 20rem;
    `}
  }
  .big-num-large-text {
    font-size: 16vw;
    line-height: .9;
    ${above.md`
      font-size: 6.5rem;
    `}
    ${above.lg`
      font-size: 7rem;
    `}
  }
  .big-num-small-text {
    font-size: 3.8vw;
    ${above.md`
      font-size: 1.4rem;
    `}
  }
  .established {
    margin: ${space.g};
    font-size: 9vw;
    ${above.md`
      font-size: 5vw;
      margin: 0;
    `}
    ${above.lg`
      font-size: 3.2rem;
      margin-top: 0;
      margin-bottom: ${space.e};
    `}
    ${above.xl`
      font-size: 2.5rem;
    `}
  }
  .established-header {
    ${above.lg`
      font-size: 1.75rem;
    `}
    ${above.xl`
      font-size: 1.25rem;
    `}
  }
  .bottom-stats {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
    padding: ${space.e} 0;
    margin: ${space.g} 0;
    ${above.md`
      border-bottom: none;
    `}
    .stat {
      line-height: 1.1;
      .stat-number {
        font-size: 5rem;
        .smaller {
          font-size: .6em;
          &.super {
            vertical-align: super;
          }
        }
      }
    }
    .stat-1 {
      flex: 0 0 100%;
      border-bottom: 1px solid #000;
      margin-bottom: ${space.e};
      padding-bottom: ${space.e};
      ${above.md`
        flex: 0 0 33%;
        border-bottom: none;
        margin-bottom: 0;
        padding-bottom: 0;
      `}
    }
    .stat-2 {
      flex: 0 0 100%;
      border-bottom: 1px solid #000;
      padding-bottom: ${space.e};
      ${above.tiny`
        flex: 0 0 50%;
        border-bottom: none;
        border-right: 1px solid #000;
        padding-bottom: 0;
      `}
      ${above.md`
        flex: 0 0 33%;
        border-left: 1px solid #000;
      `}
    }
    .stat-3 {
      flex: 0 0 100%;
      ${above.tiny`
        flex: 0 0 50%;
      `}
      ${above.md`
        flex: 0 0 33%;
      `}
    }
  }
`
